import axios from 'axios';

const http = axios.create({
    //   baseURL: "http://localhost:8080",
    baseURL: "https://api.devjudicialacademy.com",
    // baseURL: "https://api.devjudicialacademy.com",
    // baseURL: "http://13.235.74.136:8080",
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
    }
});

// Attach token dynamically before every request
http.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default http;
